import type { ProcedureModel } from '@ctw/shared/api/fhir/models/procedure';
import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import { RelatedDocumentsList } from '@ctw/shared/content/related-documents/related-documents-list';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { entryFromArray } from '@ctw/shared/utils/entry-from-array';
import { tw } from '@ctw/shared/utils/tailwind';

export const procedureDrawerAction: UseResourceDrawerOpenDrawerArgs<'Procedure'>['action'] = ({
  model,
  requestContext,
}) => ({
  label: 'Procedure',
  title: model.title,
  width: 'wide',
  content: {
    body: (
      <div className={tw`flex flex-col gap-5`}>
        <ContentCard
          variant="focal"
          title="Details"
          content={{
            header: <ResponsiveSourceDocumentLink model={model} />,
          }}
        >
          <DefinitionList items={procedureData(model, requestContext.builderId ?? '')} />
        </ContentCard>
        <ProcedureDocumentsSection model={model} />
      </div>
    ),
  },
});

interface ProcedureDocumentsSectionProps {
  model: ProcedureModel;
}

const ProcedureDocumentsSection = ({ model }: ProcedureDocumentsSectionProps) => (
  <RelatedDocumentsList binaryIds={model.relatedDocumentBinaryIds} />
);

/** Builds definition list items for the procedure details card. Data source is at the bottom. */
export const procedureData = (procedure: ProcedureModel, builderId: string) => [
  { label: 'Status', value: procedure.statusDisplay },
  { label: 'Date Performed', value: procedure.performedDisplay },
  ...entryFromArray('Performed By', procedure.performers),
  { label: 'Category', value: procedure.category },
  ...entryFromArray('Body Site', procedure.bodySites),
  ...entryFromArray('Reason', procedure.reasons),
  { label: 'Outcome', value: procedure.outcome },
  { label: 'Data Source', value: procedure.getDataSourceDisplay(builderId) },
];
